import type { HTMLComponent } from "@commercekit/react";
import { useLocalePath } from "@commercekit/remix";
import { asText } from "@prismicio/helpers";
import type { BooleanField, RichTextField } from "@prismicio/types";
import { useLocation } from "@remix-run/react";
import classNames from "classnames";
import { useMemo } from "react";
import type { LayoutDocumentDataShowPromoBarOnPagesItem } from "~/lib/prismic";
import WvLink from "../atoms/WvLink";
import { useWvPromoBarClick } from "~/hooks/useDataLayer";

const WvPromoBar: HTMLComponent<{
  promoBarText: RichTextField;
  promoBarProductLink: RichTextField;
  showPromoBar: BooleanField;
  promoBarOnAllPages: BooleanField;
  showPromoBarOnPages: LayoutDocumentDataShowPromoBarOnPagesItem[];
}> = ({
  promoBarText,
  promoBarProductLink,
  showPromoBar,
  promoBarOnAllPages,
  showPromoBarOnPages,
}) => {
  const currentLocation = useLocation();
  const localePath = useLocalePath();

  const showPromobarOnCurrentPage = useMemo(
    () =>
      promoBarOnAllPages ||
      showPromoBarOnPages.filter((item) =>
        (currentLocation.pathname === "/"
          ? "home"
          : currentLocation.pathname
        ).includes(asText(item.pathname))
      ).length > 0,
    [currentLocation, showPromoBarOnPages]
  );
  const showPromoBarOnThisPage = promoBarOnAllPages
    ? promoBarOnAllPages
    : showPromobarOnCurrentPage;

  const hideHeader = useMemo(
    () =>
      [localePath(`/checkout`), localePath(`/cart`)].includes(
        currentLocation.pathname
      ),
    [localePath, currentLocation.pathname]
  );
  const gtmPromoBarClick = useWvPromoBarClick();
  return (
    <>
      {showPromoBar && showPromoBarOnThisPage ? (
        <div
          className={classNames("visible promobar promobar-black p-md-2", {
            "hide-promobar": hideHeader,
          })}
        >
          <div className="container">
            <div className="text-center row justify-content-center">
              <WvLink
                to={asText(promoBarProductLink)}
                className="py-1 promobar-link py-lg-0"
                onClick={() => gtmPromoBarClick(asText(promoBarText), asText(promoBarProductLink))}
              >
                <i className="zmdi" data-icon-before=""></i>
                {asText(promoBarText)}
              </WvLink>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
export default WvPromoBar;
